<template>
  <div>
    <success-snackbar
      v-if="showSuccessSnackbar"
      :snackbarText="snackbarText"
      @hidde="showSuccessSnackbar = false"
    />
    <div class="section-background">
      <h3 class="section-name">Головне зображення</h3>

      <div
        class="drop-zone"
        @dragover.prevent
        @dragenter.prevent
        @dragenter="isDragging = true"
        @dragleave="isDragging = false"
        @drop.prevent="handleDrop"
        :style="isDragging ? 'border-color:#007BFF;' : ''"
      >
        <v-col cols="8" v-if="mainImage && mainImage.link" class="text-center">
          <img
            :src="mainImage.link"
            width="264px"
            height="181px"
            style="object-fit: cover"
          />
          <p
            style="
              color: #a6a6ac;
              text-align: center;
              font-size: 14px;
              font-style: normal;
              font-weight: 400;
              line-height: 16px;
              margin: 10px 0px;
            "
          >
            {{ mainImage.name }}
          </p>
          <admin-submit-button height="38px" @click="triggerFileInput"
            >Змінити зображення</admin-submit-button
          >
          <v-col cols="12" class="text-center" v-if="imageError">
            <p style="color: red">{{ imageError }}</p>
          </v-col>
        </v-col>

        <v-col cols="4" class="text-center" v-else>
          <v-icon color="#838B94" size="40px">mdi-cloud-upload</v-icon>
          <p style="margin: 22px 0px">
            Перетягніть зображення розміром 1440×984 сюди або
          </p>
          <admin-submit-button height="38px" @click="triggerFileInput"
            >Виберіть зображення</admin-submit-button
          >
          <v-col cols="12" class="text-center" v-if="imageError">
            <p style="color: red">{{ imageError }}</p>
          </v-col>
        </v-col>
      </div>
      <input
        type="file"
        ref="fileInput"
        accept="image/png, image/jpeg"
        style="display: none"
        @change="handleFileSelect"
      />
    </div>
    <loader v-if="isShowLoader" />
    <div v-else class="section-background">
      <v-row no-gutters style="margin-bottom: 22px">
        <h3 class="section-name">Список соціальних мереж</h3>
        <v-row no-gutters justify="end">
          <admin-submit-button
            height="38px"
            @click="isShowCreateSocialModal = true"
            :disabled="socialLinksList.length > 5"
            ><v-icon color="#FFFFFF" style="margin-right: 4px" size="22px"
              >mdi-plus</v-icon
            >
            Додати посилання</admin-submit-button
          >
        </v-row>
      </v-row>
      <v-data-table
        :headers="headers"
        :items="socialLinksList"
        hide-default-footer
        hide-default-header
        :items-per-page="100"
        background-color="red"
        no-data-text="Жодного соціального посилання не було додано"
      >
        <template v-slot:header="{ props }">
          <th
            @click="
              head.sortable && head.sortable !== false
                ? setSortField(head.value)
                : ''
            "
            v-for="head in props.headers"
            :key="head.id"
            style="padding: 15px"
          >
            <v-row
              no-gutters
              align="center"
              :justify="head.align ? head.align : 'start'"
              ><output
                style="
                  color: #18181b;
                  font-family: Manrope;
                  font-size: 13px;
                  font-style: normal;
                  font-weight: 700;
                  line-height: 22px;
                  cursor: pointer;
                  user-select: none;
                "
                >{{ head.text }}
                <v-icon
                  v-if="head.sortable !== false"
                  size="25px"
                  :color="head.value == sortBy ? 'black' : ''"
                  >mdi-menu-swap</v-icon
                >
              </output>
            </v-row>
          </th>
        </template>
        <template v-slot:[`item.icon`]="{ item }">
          <img
            :src="item.icon_url"
            width="40px"
            height="40px"
            style="object-fit: cover; border-radius: 4px"
          />
        </template>
        <template v-slot:[`item.link`]="{ item }">
          <a :href="item.link">{{ item.link }}</a>
        </template>
        <template v-slot:[`item.action`]="{ item }">
          <v-row no-gutters justify="end">
            <div style="width: max-content">
              <admin-submit-button @click="setItemForEdit(item)" height="38px">
                <v-icon color="#FFFFFF" style="margin-right: 4px"
                  >mdi-pencil-outline</v-icon
                >
                Редагувати</admin-submit-button
              >
              <admin-submit-button
                @click="
                  (isShowConfirmDeleteModal = true), (itemForDelete = item)
                "
                style="background: #d32f2f; margin-left: 10px"
              >
                <v-icon color="#FFFFFF" style="margin-right: 4px"
                  >mdi-delete-outline</v-icon
                >
                Видалити</admin-submit-button
              >
            </div>
          </v-row>
        </template>
      </v-data-table>
    </div>
    <create-social-link-modal
      v-if="isShowCreateSocialModal"
      :visible="isShowCreateSocialModal"
      :isEdit="isEdit"
      :itemForEdit="itemForEdit"
      @success="success"
      @close="(isShowCreateSocialModal = false), (isEdit = false)"
    />
    <confirm-delete-modal
      v-if="isShowConfirmDeleteModal"
      :visible="isShowConfirmDeleteModal"
      title="Видалити посилання"
      text="Ви впевнені, що хочете видалити це посилання?
Цю дію не можна скасувати."
      @confirm="deleteSocialLink"
      @close="isShowConfirmDeleteModal = false"
    />
  </div>
</template>

<script>
import bannerService from "../../../requests/Admin/bannerService";
import socialLinkService from "../../../requests/Admin/socialLinkService";
import adminSubmitButton from "../../UI/Btns/adminSubmitButton.vue";
import Loader from "../../UI/Loader.vue";
import ConfirmDeleteModal from "../../UI/Modals/confirmDeleteModal.vue";
import SuccessSnackbar from "../../UI/Snackbars/successSnackbar.vue";
import CreateSocialLinkModal from "./createSocialLinkModal.vue";
export default {
  components: {
    adminSubmitButton,
    CreateSocialLinkModal,
    ConfirmDeleteModal,
    Loader,
    SuccessSnackbar,
  },
  data: () => ({
    socials: [],
    headers: [
      { text: "Іконка", value: "icon", sortable: false, align: "start" },
      { text: "Назва", value: "name", sortable: false, align: "start" },
      { text: "Посилання", value: "link", sortable: false, align: "start" },
      { text: "Опції", value: "action", sortable: false, align: "end" },
    ],
    socialLinksList: [],
    allowedTypes: ["image/png", "image/jpeg"],
    maxSize: 1024 * 1024, // 1MB
    imageError: "",
    isDragging: false,
    mainImage: null,
    isShowCreateSocialModal: false,
    isShowConfirmDeleteModal: false,
    isEdit: false,
    isShowLoader: true,

    showSuccessSnackbar: false,
    snackbarText: "",
    itemForEdit: {},
    itemForDelete: {},
  }),
  mounted() {
    this.getSocialLinks();
    this.getMainBanner();
  },
  methods: {
    success(snackbarText) {
      this.isShowCreateSocialModal = false;
      this.showSuccessSnackbar = true;
      this.snackbarText = snackbarText;
      this.showLoader = true;
      this.getSocialLinks();
    },
    async getSocialLinks() {
      await socialLinkService.getSocialLinks().then((res) => {
        this.socialLinksList = res?.[0];
        this.isShowLoader = false;
      });
    },
    async getMainBanner() {
      await bannerService.getBanners().then((response) => {
        this.mainImage = response.find(
          (banner) => banner.name === "main_banner"
        );
      });
    },
    setItemForEdit(item) {
      this.itemForEdit = {
        ...item,
        icon: {
          path: item.icon_url,
        },
      };
      this.isEdit = true;
      this.isShowCreateSocialModal = true;
    },
    async deleteSocialLink() {
      this.isShowConfirmDeleteModal = false;
      await socialLinkService
        .deleteSocialLink(this.itemForDelete.id)
        .then(() => {
          this.isShowLoader = true;
          this.getSocialLinks();
          this.snackbarText = "Соціальну мережу видалено";
          this.showSuccessSnackbar = true;
        });
    },
    triggerFileInput() {
      this.$refs.fileInput.click();
    },

    async addFiles(newFile) {
      this.imageError = "";
      const file = newFile && newFile[0];
      if (!file) return;

      if (!this.allowedTypes.includes(file.type)) {
        this.imageError =
          "Невірний формат файлу. Дозволені формати: PNG або JPG.";
        return false;
      }

      if (file.size > this.maxSize) {
        this.imageError = `Файл ${file.name} перевищує 1MB`;
        return false;
      }

      this.mainImage = {
        id: Date.now(),
        link: URL.createObjectURL(file),
        name: file.name,
        file,
      };
      const form = new FormData();
      form.append("link", this.mainImage.file);
      form.append("section_id", "57a383ad-a595-4792-a558-d889a442ecaa");
      form.append("name", "main_banner");
      await bannerService
        //.createBanner(form)
        .updateBanner("ceae1657-8108-45f9-89e5-cba68d8dc417", form)
        .then(() => {
          this.snackbarText = "Головне зображення оновлено";
          this.showSuccessSnackbar = true;
        });
      this.isDragging = false;
      this.imageError = "";
    },

    deleteImage() {
      this.mainImage = null;
    },

    handleDrop(event) {
      event.preventDefault();
      event.stopPropagation();
      const droppedFiles = event.dataTransfer.files;
      this.addFiles(droppedFiles);
    },

    handleFileSelect(event) {
      const selectedFiles = event.target.files;
      this.addFiles(selectedFiles);
    },
  },
};
</script>

<style scoped>
.drop-zone {
  width: 100%;
  height: 295px;
  border-radius: 4px;
  border: 1px dashed #e4e4e7;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin-top: 26px;
  color: #000;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
}
</style>